import dynamic from 'next/dynamic'
import { getRoot } from 'mobx-state-tree'
import { REQUEST_STATUSES, TRAFFIC_STATUS } from '~/utilities/constants'
import * as TrafficTicketService from '~/services/trafficTicket'
import TRACKING from '~/services/tracking'
import { SCREEN_KEYS } from '~/components/traffic-tickets/screens'
import BasicLoader from '~/components/traffic-tickets/screens/basicLoader'
import  {
  getStepFromSlug
} from '~/components/traffic-tickets/steps/steps'
// import DUMMY_QUOTE from './dummyQuote'
const TRAFFIC_TICKET_KEYS_TO_SAVE = [
  'status'
]

const ATTORNEY_SELECTOR_CONFIGURATION = {
  slug: 'attorney',
  Component: dynamic(() => import('./index'), {
    loading: BasicLoader
    // ssr: false
  }),
  validateKeys: ['attorney'],
  validatationTarget: self => self.trafficTickets,
  onEnter: async self => {
    self.setScreen(SCREEN_KEYS.attorneyLoader)
    // const start = new Date()
    if (self.quotesStatus !== REQUEST_STATUSES.loading) {
      self.setQuotesStatus(REQUEST_STATUSES.loading)
      try {
        const ticket = self.trafficTickets[0]
        const rootStore = getRoot(self)
        const attorneyQuotes = await TrafficTicketService.getQuotes(
          ticket,
          rootStore.auth.user.sessionToken
        )
        await ticket.fetchCaseProtection(rootStore.auth.user.sessionToken)
        self.setQuotes(attorneyQuotes)
        const alreadyHasAttorney = self.trafficTickets.reduce((curr, i) => {
          if (i.attorney && i.winItPrice) return true
          return curr
        }, false)
        if (alreadyHasAttorney) {
          ticket.selectAttorney(self.quotes[0])
        } else {
          ticket.selectQuote(self.quotes[0])
        }
        // Select first attorney automatically
        // if one attorney skip to checkout page
        const {isStateAffiliatedWithWinitLaw} = rootStore.trafficSubmission
        if (self.quotes.length === 1 || isStateAffiliatedWithWinitLaw) {
          const ticketSavePromises = self.trafficTickets.map(trafficTicket => {
            trafficTicket.setStatus(TRAFFIC_STATUS.pendingConf)
            return trafficTicket.updateTicket(
              TRAFFIC_TICKET_KEYS_TO_SAVE,
              rootStore.auth.user.sessionToken
            )
          })

          await Promise.all(ticketSavePromises)

          // if only one attorney skip attorney selection screen
          // self.setStep(self.getStepFromSlug('case-details'))
        }
        if (isStateAffiliatedWithWinitLaw) {
          self.setStep(getStepFromSlug('payment-details', rootStore.trafficSubmission.selectedState.available))
        }

        self.setQuotesStatus(REQUEST_STATUSES.complete)
        // if (process.browser) {
        //   await Delays.buildMsDelayPromise(
        //     start,
        //     TRAFFIC_CONFIG.ATTORNEY_LOAD_TIME
        //   )
        // }

        if (self.quotes.length === 1) {
          self.setScreen(null)
          return true
        }
      } catch (error) {
        if (process.env.WINIT_ENV !== 'test') {
          console.error('Error fetching attorney quotes', error)
        }
        self.showErrorToast(`Issue fetching ticket quotes: ${error}`)
        self.setQuotesStatus(REQUEST_STATUSES.error)
      }
    }
    self.setScreen(null)
    self.setIsLoading(false)
  },
  onExit: async self => {
    let saved = false

    try {
      const ticketSavePromises = self.trafficTickets.map(ticket => {
        ticket.setStatus(TRAFFIC_STATUS.pendingConf)
        return ticket.updateTicket(TRAFFIC_TICKET_KEYS_TO_SAVE)
      })

      await Promise.all(ticketSavePromises)
      saved = true
    } catch (err) {
      self.showErrorToast(
        'We had an issue updating your ticket information. Please try again.'
      )
      saved = false
      if (process.env.WINIT_ENV !== 'test') {
        console.error('error updating ticket with attorney selected', err)
      }
    }
    // track with google conversion ticket switched to pendingConf
    if(saved) TRACKING.traffic.pendingConf(self.trafficTickets[0].objectId)
    return saved // to allow continue
  }
}

export default ATTORNEY_SELECTOR_CONFIGURATION
